import React, { useRef } from 'react';
var VeltNotificationsPanelSettingsAccordionTrigger = function (props) {
    var accordionConfig = props.accordionConfig, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-settings-accordion-trigger", { ref: ref, "accordion-config": accordionConfig ? (typeof accordionConfig === 'string' ? accordionConfig : JSON.stringify(accordionConfig)) : undefined }, children));
};
export default VeltNotificationsPanelSettingsAccordionTrigger;
